import { render } from "./ContentComposer.vue?vue&type=template&id=146d115f&scoped=true"
import script from "./ContentComposer.vue?vue&type=script&lang=js"
export * from "./ContentComposer.vue?vue&type=script&lang=js"

import "./ContentComposer.vue?vue&type=style&index=0&id=146d115f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146d115f"]])

export default __exports__